/*
 * @Description:
 * @Author: Leyton
 * @LastEditors: Leyton
 * @LastEditTime: 2022-06-10 10:29:16
 * @FilePath: /91qs_answer_frontpro/src/pages/checkbox/TextCheckbox/index.js
 */
import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import { CheckSquareOutlined } from "@ant-design/icons";
import { cloneDeep } from "lodash";
import { contexData } from "@/store";

function TextCheckbox({ info, answer, changeAnswer }) {
  const { options, id, description } = info;
  const [active, setActive] = useState([]);
  const { infoContex } = useContext(contexData);

  useLayoutEffect(() => {
    Array.from(document.getElementsByTagName("site")).forEach((element) => {
      const value = element.getAttribute("codeValue");
      const newElement = document.getElementById(value);
      // console.log(newElement, element);
      if (newElement) element.replaceWith(newElement);
    });
  });

  const handleClick = (opt) => {
    if (active.includes(opt.id)) {
      const newActive = cloneDeep(active);
      const index = newActive.indexOf(opt.id);
      newActive.splice(index, 1);
      setActive(newActive);
    } else {
      setActive([...active, opt.id]);
    }
  };

  useEffect(() => {
    let obj = {};
    active.map((id) => (obj[id] = null));
    changeAnswer(obj);
  }, [active]);

  useEffect(() => {
    try {
      const keys = Object.keys(answer[id]);
      if (keys.length !== active.length) setActive(keys);
    } catch (error) { }
  }, [answer, id]);
 
  return (
    <div>
      {options.map((opt) => {
        if (opt.description.includes("<img")) {
          const src = opt.description
            .match(/src=".*?"/)[0]
            .replace('src="', "")
            .replace('"', "");
          return (
            <div
              id={opt.codeValue}
              key={opt.id}
              style={{
                position: "relative",
                // display: "inline-block",     
                // border:active.includes(opt.id)&&"2px solid blue"

              }}
            >
              {active.includes(opt.id) && (
                <CheckSquareOutlined
                  style={{
                    position: "absolute",
                    color: "blue",
                    fontWeight: 800,
                    left: 2,
                    top: 2
                  }}
                />
              )}
              <span
                onClick={() => handleClick(opt)}
                style={{
                  display: "inline-block",
                  cursor: "pointer",

                }}

                className={active.includes(opt.id) && "aaa"} dangerouslySetInnerHTML={{ __html: opt.description }}></span>
              {/* <img src={src} alt={src} /> */}
              <style>

                {
                  `.aaa img
                  {
                    background-color: #d6e4ff;
                    border: 2px solid #40a9ff;
                  }`
                }
              </style>
            </div>
          );
        }
        return (
          <span
            id={opt.codeValue}
            key={opt.id}
            style={{
              cursor: "pointer",
              backgroundColor: active.includes(opt.id) ? "#d6e4ff" : "transparent",
              padding: active.includes(opt.id) ? "0 4px" : "0",
              borderRadius: "3px",
            }}
            onClick={() => handleClick(opt)}
            dangerouslySetInnerHTML={{
              __html: opt.description.replace(/<(?!\/?span\b)[^>]+>/gi, ""),
            }}
          />
        );
      })}

      <div
        style={{}}
        dangerouslySetInnerHTML={{
          __html: description
            .replace(/<site[^>]*>[\s\S]*?<\/site>/g, (match) => {
              return match.replace(/(<site[^>]*>)[\s\S]*?(<\/site>)/, '$1$2');
            })
            .replace(/<p><\/p>/g, "<br />"),
        }}
      />
    </div>
  );
}

export default TextCheckbox;
